// extracted by mini-css-extract-plugin
export default {"form":"CreateTopic_form__BLYBE","button":"CreateTopic_button__NYN1Z"};